import { getCachedData, putCachedData } from "./offlineDb"
import { mergeReportDataRecords, reconcileReportList } from "../utils/reportIdentity"

// Serialize snapshots and reconcile identities across both dashboard caches.
// A synced report replaces its placeholder instead of creating a second key.
export const createReportCacheWriter = () => {
  let pending = Promise.resolve()
  return (records, recentReports, resolvedIds = {}) => {
    pending = pending.catch(() => {}).then(async () => {
      const [cached, cachedRecent, savedIds] = await Promise.all([
        getCachedData("audit-reports:all-with-data"),
        getCachedData("audit-reports:recent"),
        getCachedData("sync:resolved-ids"),
      ])
      const aliases = { ...savedIds, ...resolvedIds }
      const merged = mergeReportDataRecords(cached, records, aliases)
      const known = merged.map(record => record.report)
      const recent = reconcileReportList(recentReports?.length ? recentReports : cachedRecent || [], known, aliases)
      await Promise.all([
        putCachedData("audit-reports:all-with-data", merged),
        putCachedData("audit-reports:recent", recent),
      ])
    })
    return pending
  }
}
